import { memo } from "react";

// icons
import { Add as AddIcon } from "@mui/icons-material";

//
import { IconButton } from "components/ui-kit/buttons/IconButton";

const AddSpecificationButton = ({
  // state
  article,
  parent,
  articles = [],
  loading = false,
  // dispatch
  selectProduct = () => { },
}) => (
  <IconButton
    icon={<AddIcon />}
    onClick={selectProduct.bind(null, { article }, parent)}
    disabled={loading || articles.includes(article)}
  />
);

export default memo(AddSpecificationButton);
